/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Medicaid/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import State from './State/index'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Medicaid({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/Medicaid",
  onChange
  
}) {
let carrierMedicaidValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'medicaid',
})
let carrierMedicaidChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'medicaid',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Medicaid.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="carrier.medicaid"
 value={carrierMedicaidValueData}
 onChange={carrierMedicaidChangeData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Medicaid"
/>
</React.Fragment>
)}
</TysiaCheckbox>
<State
  viewPath={`${viewPath}/State`}
/>
</div>
{children}
</React.Fragment>)
}